import isFunction from 'lodash/isFunction';
import { ColorPicker } from 'primereact/colorpicker';
import React from 'react';
import { SegmentEventTypes } from '../../data/tracking';
import Analytics from '../../utils/Analytics';
import LabelWrapper from '../LabelWrapper.component';

export const WrappedColorPicker = props => {
	const {
		className,
		dataqa = 'common',
		isInputInvalid,
		onChange,
		...config
	} = props;

	const clickHandler = e => {
		Analytics.trackSegmentInputEvent({
			trackingData: {
				field_type: 'colorpicker',
				field_name_dataqa: `ui-colorpicker-${dataqa}`,
			},
			eventType: SegmentEventTypes.UserInputCompleted,
		});

		if (isFunction(onChange)) {
			onChange(e);
		}
	};

	return (
		<div className="common-ui-colorpicker">
			<ColorPicker
				className={className}
				{...config}
				data-qa={`ui-colorpicker-${dataqa}`}
				dataqa={`ui-colorpicker-${dataqa}`}
				onChange={clickHandler}
			/>
		</div>
	);
};

export const WrappedColorPickerWithLabel = LabelWrapper(WrappedColorPicker);
